// A cutoff point (in pixels to switch to desktop layout)
export const DESKTOP_CUTOFF_POINT = 992;
export const MOBILE_CUTOFF_POINT = 991;
